export default "__VITE_ASSET__tHL_0ku2__"